/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMcp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M15.018 3.965a2.117 2.117 0 0 0-2.954 0L4.188 11.69a.706.706 0 0 1-.984 0 .673.673 0 0 1 0-.966L11.08 3a3.529 3.529 0 0 1 4.922 0 3.367 3.367 0 0 1 .985 2.896 3.518 3.518 0 0 1 2.953.966l.04.04a3.367 3.367 0 0 1 0 4.828l-7.123 6.984a.225.225 0 0 0 0 .322l1.463 1.435a.673.673 0 0 1 0 .965.706.706 0 0 1-.984 0l-1.463-1.434a1.572 1.572 0 0 1 0-2.253l7.123-6.986a2.02 2.02 0 0 0 0-2.896l-.04-.04a2.117 2.117 0 0 0-2.952-.002l-5.868 5.755-.001.001-.08.08a.706.706 0 0 1-1.136-.221.673.673 0 0 1 .15-.745l5.95-5.836a2.02 2.02 0 0 0-.002-2.894z" />
        <path d="M14.033 5.896a.673.673 0 0 0 0-.965.706.706 0 0 0-.985 0l-5.824 5.712a3.367 3.367 0 0 0 0 4.827 3.53 3.53 0 0 0 4.922 0l5.825-5.712a.673.673 0 0 0 0-.965.706.706 0 0 0-.985 0l-5.825 5.712a2.117 2.117 0 0 1-2.953 0 2.021 2.021 0 0 1 0-2.896z" />
      </g>
    </g>
  </Icon>
);
export { SvgMcp as Mcp };
